/* eslint-disable no-restricted-imports */
import clsx from 'clsx'
import React, {useMemo} from 'react'
import styles from './AdBox.module.scss'
import {ClientUserState} from '../../../../../../../code/client/shared/scripts/ClientUserState'
import {ColonistMembershipType, ModeSettingEnum} from '@colonist/types'
import {AjaxDataTypes} from '../../../../../../../code/shared/AjaxDataTypes'
import {
    AnalyticEventCategory,
    AnalyticEventType,
    AnalyticEventValue,
} from '../../../../../../../code/shared/entity_datas/EntityDatas'
import {CA} from '../../../../../../../code/client/shared/scripts/analytics/Analytics'
import {T} from '@colonist/ui'
import {AD_BOX_CONTENT} from '../../constants'
import {navigateToPage} from '../../../../../../../code/client/shared/scripts/ui_utils/ClientUtils'
import {UIUrlParameterNames} from '../../../../../../../code/client/shared/scripts/ui_html/UIUrlController'
import {UIEntryUrlParameterController} from '../../../../../../../code/client/shared/scripts/UIEntryUrlParameterController'
import {uiManagerEvents} from '../../../../../../../code/client/shared/scripts/EntryShared'
import {UIUtilsEjsVariables} from '../../../../../../../code/client/shared/scripts/UIUtilsEjsVariables'
import {useGameStore} from '../../../../store/GameStoreContext'
import {useIsReplay} from '../../../../store/selectors/useIsReplay'

export interface AdBoxProps {
    className?: string
}

export const AdBox = ({
    className,
}: AdBoxProps) => {
    const isReplay = useIsReplay()
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)

    const shouldShowEndGameItemBox = useMemo(() => {
        const isBeginnerMode = modeSetting == ModeSettingEnum.BeginnerModeClassic4P
        if(isReplay || isBeginnerMode) return false

        if(ClientUserState.userState == undefined) return true
        const items = ClientUserState.userState.items
        if(items.hasFoundersPack()) return false
        const membershipType = items.membership
        switch(membershipType) {
            case ColonistMembershipType.EliteMonthly:
            case ColonistMembershipType.EliteYearly:
            case ColonistMembershipType.PremiumMonthly:
            case ColonistMembershipType.PremiumYearly:
                return false
            default:
                return true
        }
    }, [])

    const adBoxContent = useMemo(() => {
        const allContent = AD_BOX_CONTENT
        const shouldNotShowRemoveAdsPerk = ClientUserState.userState?.items.hasMembership()
        if(shouldNotShowRemoveAdsPerk) {
            return allContent.filter((content) => !content.isRemoveAdContent)
        }
        return allContent
    }, [])

    const onClickAdBox = () => {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.ItemBoxMembershipEndgame,
        }
        void CA.sendAnalyticEvent(eventData)
        if(UIUtilsEjsVariables.isUserOnDiscord) {
            uiManagerEvents.handleUrlRedirectViaParameters(UIUrlParameterNames.DiscordStore, UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE)
            return
        }
        navigateToPage('/store#membership', true)
    }
    const randomIndex = useMemo(() => Math.floor(Math.random() * adBoxContent.length), [adBoxContent])

    if(!shouldShowEndGameItemBox) return null

    return <div className={clsx(styles.container, className)}>
        <div className={styles.imageContainer}>
            <img
                className={styles.image}
                onClick={onClickAdBox}
                src={adBoxContent[randomIndex].image} />
        </div>
        <div className={styles.text}>
            <T id={adBoxContent[randomIndex].title}/>
        </div>
    </div>
}
